import { useIntl } from 'react-intl';

import { commonMessages } from '@/messages/common';
import { listingActions } from '@/states/listingState';

import { ReactComponent as FilterSvg } from '@/assets/icons/filter.svg';

import * as S from './FiltersButton.styles';

export const FiltersButton = ({ isWidget = false }: { isWidget?: boolean }) => {
  const { formatMessage } = useIntl();

  const handleClick = () => {
    if (isWidget) {
      window.parentIFrame?.autoResize(false);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      window.parentIFrame?.resize(1024 as any);
    }

    listingActions.updateModalState({
      status: 'OPEN',
    });
  };

  return (
    <S.FiltersButton data-testid='FiltersButton' onClick={handleClick}>
      {formatMessage(commonMessages.filters)}
      <FilterSvg />
    </S.FiltersButton>
  );
};

FiltersButton.displayName = 'FiltersButton';
